import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc, getDocs, collection, query, where } from "firebase/firestore";
import { db } from "../../firebase";
import style from "./ItemPage.module.css";

import logoAr from '../../assets/images/logoAr.png';
import logoEn from '../../assets/images/logoEn.png';
import boltLogo from '../../assets/logos/bolt.jpg';
import mounershLogo from '../../assets/logos/mounersh3d.png';

export default function ItemPage() {
    const { gameId, itemId } = useParams();
    const [item, setItem] = useState(null);
    const [giftDetails, setGiftDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        async function loadItem() {
            try {
                const itemsCollectionPath = `games/${gameId}/items`;
                let itemFound = false;
                
                for (let i = 1; i <= 15; i++) {
                    const itemRef = doc(db, itemsCollectionPath, `item${i}`);
                    const itemSnapshot = await getDoc(itemRef);
                    
                    if (itemSnapshot.exists()) {
                        const itemData = itemSnapshot.data();

                        if (itemData.itemId === itemId) {
                            setItem(itemData);
                            itemFound = true;
                            
                            if (itemData.isWinning && itemData.gift) {
                                await loadGiftDetails(itemData.gift);
                            }
                            break;
                        }
                    }
                }
                
                if (!itemFound) {
                    setError("العنصر غير موجود");
                }
            } catch (err) {
                console.error("Error loading item:", err);
                setError("فشل تحميل العنصر");
            } finally {
                setLoading(false);
            }
        }

        async function loadGiftDetails(giftName) {
            try {
                const giftsRef = collection(db, "gifts");
                const q = query(giftsRef, where("name", "==", giftName));
                const querySnapshot = await getDocs(q);
                
                if (!querySnapshot.empty) {
                    const giftDoc = querySnapshot.docs[0];
                    setGiftDetails(giftDoc.data());
                } else {
                    setGiftDetails({ name: giftName });
                }
            } catch (err) {
                console.error("Error loading gift details:", err);
                setGiftDetails({ name: giftName });
            }
        }

        if (gameId && itemId) {
            loadItem();
        } else {
            setError("معرف اللعبة أو العنصر غير صحيح");
            setLoading(false);
        }
    }, [gameId, itemId]);

    if (loading) {
        return (
            <div className={style.page}>
                <div className={style.imgbg}/>
                <div className={style.bg}/>
                <div className={style.container}>
                    <div className={style.logos}>
                        <img className={style.logoAr} src={logoAr} alt="Logo AR" />
                        <img className={style.logoEn} src={logoEn} alt="Logo EN" />
                    </div>
                    <p className={style.loading}>جاري التحميل...</p>
                </div>
            </div>
        );
    }

    if (error || !item) {
        return (
            <div className={style.page}>
                <div className={style.imgbg}/>
                <div className={style.bg}/>
                <div className={style.container}>
                    <div className={style.logos}>
                        <img className={style.logoAr} src={logoAr} alt="Logo AR" />
                        <img className={style.logoEn} src={logoEn} alt="Logo EN" />
                    </div>
                    <p className={style.error}>{error || "العنصر غير موجود"}</p>
                </div>
            </div>
        );
    }

    const isWinner = item.isWinning || false;

    function getGiftLogo(giftName) {
        if (!giftName) return null;
        const name = giftName.toLowerCase();
        if (name.includes('bolt')) return boltLogo;
        if (name.includes('mounersh')) return mounershLogo;
        return null;
    }

    return (
        <div className={style.page}>
            <div className={style.imgbg}/>
            <div className={style.bg}/>
            <div className={style.container}>
                <div className={style.resultCard}>
                    <div className={style.logos}>
                        <img className={style.logoAr} src={logoAr} alt="Logo AR" />
                        <img className={style.logoEn} src={logoEn} alt="Logo EN" />
                    </div>
                    {isWinner ? (
                        <>
                            <div className={style.winnerHeader}>
                                <h1 className={style.winnerTitle}>🎉 مبروك! 🎉</h1>
                                <p className={style.winnerSubtitle}>لقد ربحت!</p>
                            </div>
                            
                            {giftDetails && (
                                <div className={style.giftInfo}>
                                    {getGiftLogo(giftDetails.name) && (
                                        <img 
                                            src={getGiftLogo(giftDetails.name)} 
                                            alt={giftDetails.name} 
                                            className={style.giftLogo} 
                                        />
                                    )}

                                    <h2 className={style.giftName}>{giftDetails.name}</h2>

                                    {/* <div className={style.contactInfo}>
                                        <p className={style.contactText}>
                                            <span className={style.contactName}>ارسله هاذا الكود على انستجرام: @mounersh3d</span>
                                            <br />
                                            <span className={style.contactCode}>{item.itemId} (الكود الخاص بالهدية)</span>
                                        </p>
                                    </div> */}
                                </div>
                            )}
                        </>
                    ) : (
                        <div className={style.loserHeader}>
                            <h1 className={style.loserTitle}>😔 حظاً أوفر في المرة القادمة!</h1>
                            <p className={style.loserSubtitle}>لم تربح هذه المرة</p>
                            <p className={style.loserMessage}>جرب مرة أخرى مع رابط آخر!</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
